import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayToString'
})
export class ArrayToStringPipe implements PipeTransform {

  transform<T>(values: T[], propertyName: string, fieldName: string, search?: string): string {
    console.log('values : ',values);
    console.log('propertyName:', propertyName);
    console.log('fieldName: ',fieldName);
    console.log('search: ', search);

    if (!search) {
      return values[propertyName].map(element => element[fieldName]).join(', ');
    }

    if (!values || values.length < 1) {
      return '';
    }

    let name: string = values[propertyName].map(element => element[fieldName]).join(', ');
    const replacePattern = '<span class="mark px-0"><strong>$&</strong></span>';

    if (search) {
      // Replace spaces to vertical bar to highlight all words in the product name "bmc oracle 64" -> "bmc|oracle|64"
      name = name.replace(new RegExp(search.replace(/ /g, '|'), 'gi'), replacePattern);
      return name;
    }

    return name.replace(new RegExp(search, 'i'), replacePattern);
  }

}
